module.exports = __webpack_public_path__ + "img/6-2.5e2f4967.jpg";